import { gql } from '@apollo/client'

export const initiateCreditCard = gql`
  mutation initiateCreditCard {
    initiateCreditCard
  }
`

export const finalizeCreditCard = gql`
  mutation finalizeCreditCard($fundId: Int!, $data: FinalizeCreditCardInput!) {
    finalizeCreditCard(fundId: $fundId, data: $data) {
      id
      paymentType
      details
      multiUse
      status
      default
    }
  }
`

export const addLinkedBank = gql`
  mutation addLinkedBank($fundId: Int!, $data: CreateEftPaymentMethodInput!) {
    addLinkedBank(fundId: $fundId, data: $data) {
      id
      paymentType
      details
      multiUse
      status
      default
    }
  }
`

export const createZumRailsUserGuest = gql`
  mutation createZumRailsUserGuest($data: CreateZumRailsUserInput!) {
    createZumRailsUserGuest(data: $data)
  }
`

export const createZumRailsUser = gql`
  mutation createZumRailsUser($data: CreateZumRailsUserInput!) {
    createZumRailsUser(data: $data)
  }
`

export const createZumRailsManualUser = gql`
  mutation createZumRailsManualUser($data: CreateZumRailsManualInput!) {
    createZumRailsManualUser(data: $data)
  }
`

export const deleteBankAccount = gql`
  mutation deleteBankAccount($fundId: Int!, $data: DeleteEftPaymentMethodInput!) {
    deleteBankAccount(fundId: $fundId, data: $data)
  }
`

export const addManualBankAccount = gql`
  mutation addManualBankAccount($data: CreateManualBankAccountInput!) {
    addManualBankAccount(data: $data) {
      id
      paymentType
      details
      status
      default
    }
  }
`

export const deactivateCharityPaymentMethod = gql`
  mutation deactivateCharityPaymentMethod($id: Int!) {
    deactivateCharityPaymentMethod(id: $id) {
      id
    }
  }
`

export const deactivateCreditCard = gql`
  mutation deactivateCreditCard($deactivateCreditCardInput: DeactivateCreditCardInput!) {
    deactivateCreditCard(DeactivateCreditCardInput: $deactivateCreditCardInput)
  }
`
